import { Injectable, signal } from '@angular/core';
import { Toast, ToastType } from './toast.model';

@Injectable({
	providedIn: 'root',
})
export class ToastsService {
	toasts = signal<Toast[]>([]);

	error(title: string, message?: string) {
		this.pushToast(ToastType.ERROR, title, message);
	}

	remove(id: number) {
		this.toasts.update((list) => list.filter((t) => t.id !== id));
	}

	serverError(res: any, title: string = 'TOAST.SOMETHING_WENT_WRONG', message?: string) {
		this.pushToast(ToastType.ERROR, title, message, res);
	}

	success(title: string, message?: string) {
		this.pushToast(ToastType.SUCCESS, title, message);
	}

	private pushToast(type: ToastType, title: string, message?: string, detail?: any) {
		const id = Date.now();

		const toast = {
			id,
			type,
			title,
			message,
			detail,
		};

		this.toasts.update((list) => [...list, toast]);
	}
}
